import * as React from 'react';
import type { DeliveryStatus } from '@hetivo/hetivo-lib-types';

import { STATUS_BADGE_COLORS } from './status-badge';
import { StatusBadge } from './status-badge';

const DELIVERY_STATUS_STYLES: Record<DeliveryStatus, string> = {
  delivered: STATUS_BADGE_COLORS.success,
  failed: STATUS_BADGE_COLORS.danger,
  in_transit: STATUS_BADGE_COLORS.info,
  pending: STATUS_BADGE_COLORS.warning,
};

export interface DeliveryStatusBadgeProps {
  /** The translated label to show inside the badge */
  label: string;
  /** The delivery status to display */
  status: DeliveryStatus;
}

export function DeliveryStatusBadge({ label, status }: DeliveryStatusBadgeProps): React.JSX.Element {
  return <StatusBadge label={label} status={status} styles={DELIVERY_STATUS_STYLES} />;
}
